<template>
  <div class="min-height-100">
    <template v-if="isMobile">
      <mobile-filter-header :show-filters="() => setMobileFilterVisibility(true)" :sorting-options="sortingOptions" />
      <mobile-filter-panel
        :total-count="pagination.totalCount"
        :show="showMobileFilter"
        :hide-filters="() => setMobileFilterVisibility(false)"
        :filter-panel-config="getFilterPanelConfig()"
      />
    </template>
    <div class="search-result-page">
      <filter-panel
        v-if="!isMobile"
        :total-count="pagination.totalCount"
        :filter-panel-config="getFilterPanelConfig()"
      ></filter-panel>
      <div class="page-content">
        <div class="page-header">
          <div class="page-title-row">
            <div class="page-title">Brands</div>
            <sorting-options v-if="!isMobile" :options="sortingOptions" />
          </div>
          <h4 v-if="isMobile && pagination.totalCount" class="mobile-total-count color-gray">
            {{ pagination.totalCount }} TOTAL RESULTS
          </h4>
          <filter-badges class="filter-badges" />
        </div>

        <template>
          <div v-if="loading" class="relative">
            <div class="loader-search" />
          </div>
          <div v-else>
            <div class="brands-grid">
              <brand-tile v-for="brand in brands" :key="'brand_' + brand.id" :data="brand" />
              <div v-if="brands.length === 0">
                <h4>no results</h4>
              </div>
            </div>
            <div class="flex justify-center mt-50 mt-25-sm">
              <pagination
                class="no-padding-right"
                :active="pagination.page"
                :total="pagination.totalCount"
                :on-click="setPage"
                :limit="pagination.limit"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../../assets/sass/searchPage/searchPage.scss"></style>
<style lang="scss" scoped>
@import "@/assets/sass/base/_mixins.scss";
.brands-grid {
  display: grid;
  width: 100%;
  grid-row-gap: 120px;
  grid-column-gap: 24px !important;
  grid-template-columns: 1fr 1fr 1fr;

  @include respond-to("small") {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 40px;
  }
}
</style>
<script>
import BrandTile from "./brandTile.vue";
import { searchPageMobileStateHelper } from "../../components/mixin/search/searchPageMobileStateHelper";
import { algoliaBrandHelper } from "../../components/mixin/search/algoliaBrandHelper";
import { FilterKeys } from "../../services/utils";

export default {
  components: {
    BrandTile,
  },
  mixins: [algoliaBrandHelper, searchPageMobileStateHelper],
  data() {
    return {
      brands: [],
      defaultSorting: "brands_sorted_timestamp",
      favoriteBrandIDsList: [],
      loading: true,
      sortingOptions: [
        {
          name: "New Arrivals",
          value: "brands_sorted_timestamp",
        },
        {
          name: "High Sell Through",
          value: "brands_sorted_total_orders",
        },
        {
          name: "Lowest MOV",
          value: "brands_sorted_mov",
        },
        {
          name: "Lowest Lead Time",
          value: "brands_sorted_lead_time",
        },
      ],
    };
  },
  watch: {
    "$route.query": function (query) {
      this.getBrandsOnSearch(query);
    },
  },
  async beforeMount() {
    await this.getFavouriteBrands();

    if (!this.$route.query.sortBy) {
      this.updateURLParams("page", 1);
      this.updateURLParams("sortBy", this.defaultSorting);
    } else {
      this.getBrandsOnSearch(this.$route.query);
    }
  },
  methods: {
    getFilterPanelConfig,
  },
};

function getFilterPanelConfig() {
  return {
    hiddenFilters: [FilterKeys.BRANDS.toString(), FilterKeys.PRICE_FROM.toString()],
  };
}
</script>
